import { BaseService } from './base-service';
import { StrainIndexReportMapper } from '@/core/mappers/strain-index-report';
import type { StrainIndexReport } from '@/types/StrainIndex';
import type {
	GetStrainIndexRequestDTO,
	GetStrainIndexReportResponseDTO
} from '@/core/dto/strain-index';

export class StrainIndexReportService extends BaseService<StrainIndexReport> {
	private static instance: StrainIndexReportService;
	private constructor(public readonly basePath: string = '/ergonomic-tool/strain-index') {
		super();
	}

	public static getInstance(): StrainIndexReportService {
		if (!StrainIndexReportService.instance) {
			StrainIndexReportService.instance = new StrainIndexReportService();
		}
		return StrainIndexReportService.instance;
	}

	public async getReport(params: GetStrainIndexRequestDTO): Promise<StrainIndexReport> {
		const url = this.basePath + `/${params.file_id}`;
		const serviceInstance = StrainIndexReportService.getInstance();
		const { data } = await serviceInstance.getInstance().get<GetStrainIndexReportResponseDTO>(url, { params });
		return new StrainIndexReportMapper(data).toDomain();
	}
}

